module.exports = __webpack_public_path__ + "img/Aggregation_Ethnien.07e52aa1.png";